import { ModalHeader } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { ModalHeaderProps } from '../../lib/types';

const { Container, Subtitle, Title } = ModalHeader;

export const ModalHeaderDefault = ({
  title,
  align = 'left',
  gap = 4,
  maxLinesSubtitle,
  maxLinesTitle,
  subtitle,
  ...props
}: ModalHeaderProps) => {
  const isCentered = align === 'center';

  return (
    <Container {...props}>
      <Stack alignItems={isCentered ? 'center' : undefined} gap={gap} textAlign={isCentered ? 'center' : undefined}>
        <Title maxLines={maxLinesTitle} ml={isCentered ? 40 : undefined} mr={40}>
          {title}
        </Title>
        {subtitle && <Subtitle maxLines={maxLinesSubtitle}>{subtitle}</Subtitle>}
      </Stack>
    </Container>
  );
};
